<!--我的形象-->
<template>
  <div class="my-profile fs18 cr">
    <div class="flex ac jb">
      <p class="bold">公共形象</p>
    </div>
    <div class="select-box">
      <div class="flex ac jb cr">
        <div class="flex ac">
          <p class="mr15" style="margin-right: 15px" @click="handleChoose(1)" :class="choosed==1?'activeId': ''">星巢公共形象</p>
          <p :class="choosed==2?'activeId': ''" @click="handleChoose(2)">用户自购形象</p>
        </div>
        <div>
          <el-input
            placeholder="名称搜索"
            v-model="selectObj.name"
          >
            <el-button slot="append" icon="el-icon-search" @click="select()"></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="my-works">
      <div class="flex ac fw" v-if="choosed==1">
        <div class="every-video" @mouseover="handleMouse(item)" @mouseleave="handleMouseOut(item)"
             @click="handlePlay(item)" v-for="(item,index) in myVideoArray" :key="index">
          <div class="img-box" :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}">
          </div>
          <img class="poster-img"
               :src="item.cover"
               alt="">
          <div v-if="hoverId==item.id">
            <div class="jp-btn-box">精品创作</div>
            <img class="bofang-box" src="../assets/images/bofang.png" alt="">
            <div class="close-box" @click.stop="handleDelete(item)">X</div>
          </div>
          <div class="pp-text">{{item.name}}</div>
        </div>
      </div>
      <div v-if="choosed==2" >
        <p class="pt30">敬请期待，可购买的形象！</p>
      </div>
    </div>

    <el-dialog
      :title="videoName"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleDialogClose"
    >
      <div class="dialog-video">
        <video ref="videoPlayer" style="width: 100%;height: 100%" controls="" autoplay="" :src="videoUrl"></video>
      </div>
      <span slot="footer" class="tc cr">
        <div class="jp-btn-box2">精品创作</div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {delVideo, getVideo} from "../api/user";

  export default {
    name: '',
    data() {
      return {
        dialogVisible: false,
        autoState: true,
        myVideoArray: [],
        selectObj: {
          source: '2', page: 1, limit: 9999, name: ''
        },
        hoverId: '',
        videoName: '',
        videoUrl: '',
        fileList: [],
        loading: '',
        videoUpName: '',
        choosed: 1
      }
    },
    created() {
      this.getMyVideoList()
    },
    methods: {
      getMyVideoList() {
        getVideo({...this.selectObj}).then(res => {
          this.myVideoArray = res.data.list
        })
      },
      handleChoose(val) {
        this.choosed = val
      },
      select() {
        this.getMyVideoList()
      },
      handleMouse(item) {
        this.hoverId = item.id
      },
      handleMouseOut() {
        this.hoverId = ''
      },
      handlePlay(item) {
        this.videoName = item.name
        this.videoUrl = item.url
        this.dialogVisible = true
      },
      handleDialogClose() {
        // 停止视频播放
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
        }
        // 重置视频源
        // this.videoSrc = '';
      },
      handleDelete(item) {
        this.$confirm('此操作将永久删除该形象, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delVideo({id: item.id}).then(() => {
            this.$message.success('删除成功')
            this.getMyVideoList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
  .my-profile::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .my-profile {
    background-color: #fff;
    box-shadow: 0 4px 12px 4px #0000000d;
    box-sizing: border-box;
    width: 100%;
    padding: 24px;
    height: calc(100vh - 95px - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    border-radius: 12px;
    p{
      margin: 0;
      padding: 0;
    }
  }
  .select-box {
    padding: 20px 0;
    height: 80px;
    width: 100%;
    .activeId{
      color: #000;
      font-weight: 700;
    }
  }

  .my-works {
    padding: 0 24px 24px 24px;
    background: #ffffff;
    border-radius: 10px;
    height: calc(100vh - 80px - 190px);

    .every-video {
      width: 280px;
      height: 250px;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      position: relative;
      cursor: pointer;
      margin: 0 25px 25px 0;

      .img-box {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 200px;
        background: rgba(0, 0, 0, .3);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100%;
        filter: brightness(.5);
        transform-origin: center center;
        object-fit: cover;
        position: relative;
        border-radius: 8px;
      }

      .poster-img {
        width: 50%;
        height: 200px;
        position: absolute;
        left: 25%;
        top: 0;
        z-index: 999;
      }

      .pp-text {
        font-size: 13px;
        padding: 0 5px;
        margin-top: 8px;
        overflow: hidden;
        width: 100%;
        height: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #232833;
        line-height: 32px;
        flex: 1;
      }

      .jp-btn-box {
        background: linear-gradient(to right, #000000, #512D7A);
        width: 76px;
        height: 30px;
        font-size: 12px;
        color: #fff;
        border-width: 0;
        border-radius: 4px;
        box-shadow: #40558029 0 4px 12px;
        font-weight: 600;
        line-height: 30px;
        text-align: center;
        position: absolute;
        right: 5px;
        bottom: 15px;
      }

      .bofang-box {
        position: absolute;
        top: 32%;
        left: 45%;
        width: 40px;
        height: 40px;
        z-index: 99999;
      }

      .close-box {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 30px;
        height: 30px;
        background: #ffffff;
        color: black;
        line-height: 30px;
        z-index: 99999;
        text-align: center;
        border-radius: 3px;
      }

    }

    .every-video:hover {
      transform: scale(1.01);
      box-shadow: 0 4px 12px #0000001a;
      transition: transform .3s ease 0s, box-shadow .3s ease 0s;
    }
  }
  .dialog-video{
    width: 100%;
    height: 440px;
  }
  .jp-btn-box2 {
    background: linear-gradient(to right, #000000, #512D7A);
    width: 76px;
    height: 30px;
    font-size: 12px;
    color: #fff;
    border-width: 0;
    border-radius: 4px;
    box-shadow: #40558029 0 4px 12px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
  }

</style>
<style>
  .my-profile .el-input {
    width: 200px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/gProfile.vue